import React, { useEffect, useState } from "react";
import ConsultantLayout from "../../commonlayouts/consultantlayout";
import CandidateLayout1 from "../../commonlayouts/candidatelayout1.js";
import Axios from "axios";
import { GetCandidateById, GetJobRoles, GetCourseInfo,GetJobPosts,AddCandidateSubmissions,SaveCandidateRecordedAudio ,GetListOfUsersWithAdminByEmployeeID, GetListOfVendorsByEmployeeID,GetCandidateSubmission,GetDocumentTypes,DeleteBlob,GetCandidateByGuid, UpdateCandidateSubmissions, DeleteCandidateSubmission } from "../../apiconstants/constants";
import { json, Link, useLocation,useNavigate } from "react-router-dom";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Modal from 'react-bootstrap/Modal';
import LoadingSpinner from "../../helpers/loadingspinner";
import { useCountry } from "../../contexts/countrycodecontext.js";
import { useForm } from "react-hook-form";
import { Accordion, Form, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import mammoth from "mammoth";
import axios from "axios";
import Select from 'react-select';
import ReactQuill from "react-quill";
import DOMPurify from "dompurify"; // optional but recommended

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const BenchViewCandidateDetailsByCandidateGUid = () => {
    let query = useQuery();
    const guid = query.get("guid");
    let Guid="";
    const {selectedCountry} = useCountry();
    const userguid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const email = localStorage.getItem("email")
    const roleID = localStorage.getItem("roleID")
    const [submissions, setSubmissions] = useState([]);
const [showSubmissionForm, setShowSubmissionForm] = useState(false);
const [isEditing, setIsEditing] = useState(false);
const [isViewMode, setIsViewMode] = useState(false);
const [selectedJobTitleId, setSelectedJobTitleId] = useState("");
const [usersList, setUsersList] = useState([]);
const [submittedBy, setSubmittedBy] = useState("");
 const [skills, setSkills] = useState([
    { Skill: "", YearsOfExp: "", Rating: "" },
  ]);
  const [showAssessmentModal, setShowAssessmentModal] = useState(false);
  const [assessmentMode, setAssessmentMode] = useState(""); // "link" or "file"
  const [assessmentFile, setAssessmentFile] = useState(null); 
const [audioValue, setAudioValue] = useState("");
const [audioFile, setAudioFile] = useState("");
const token = localStorage.getItem("jwtToken");
const [internalSubmission, setInternalSubmission] = useState(null);

  
const navigate = useNavigate();
// Fetch Submissions List
const fetchSubmissions = async () => {
  try {
    const url = GetCandidateByGuid.APIURL;
    const payload = { guid: guid };

    const res = await Axios.post(url, payload, {
      headers: { Authorization: `Bearer ${token}` }
    });

    const allSubs = res.data?.submissions || [];
    setSubmissions(allSubs);

    // Pick Internal Bench submission
    const internal = allSubs.find(
      (s) => s.candidateType === "Internal Bench"
    );

    setInternalSubmission(internal);

  } catch (err) {
    console.error("Error fetching submissions:", err);
  }
};
const hasAttachments =
  internalSubmission?.fileUrl ||
  internalSubmission?.rtR_PDFdoc ||
  internalSubmission?.resume_Insights_Pdfdoc ||
  internalSubmission?.othersdoc ||
  internalSubmission?.visaCopyUrl ||
  internalSubmission?.drivingLicenceUrl ||
  internalSubmission?.i94File ||
   internalSubmission?.passportURL ;

  const GetUsersList = async () => {
     setIsLoading(true);
 
     const GetapiUrl =  GetListOfUsersWithAdminByEmployeeID.APIURL + `?EmployeeGuid=${Guid}`;
 
   await  Axios.get(GetapiUrl,
        { headers: { Authorization: `Bearer ${token}` } }
   )
       .then((result) => {
         setIsLoading(false);
 const filteredusers = result.data?.filter(user =>
   user.countryMappings?.includes(selectedCountry)
 );
        setUsersList(filteredusers || []);
       }).catch((error) => {
         console.log("Error" + error);
       });
   };
// Fetch Single Submission by ID
const fetchSubmissionById = async (submissionId) => {
  try {
    if (!submissionId) {
      console.error("❌ submissionId is undefined. Cannot fetch submission details.");
      return;
    }

    const url = `${GetCandidateSubmission.APIURL}?submissionGuid=${submissionId}`;
    console.log("Fetching submission details from:", url);

    const res = await Axios.get(url,
      { headers: { Authorization: `Bearer ${token}` } }

    ); // ✅ added await
    const data = res.data || {};
    setSubmissionData(data); // ✅ store for reuse in edit submit

 if (res.data?.experience) {
  const exp = res.data.experience.match(/(\d+)\s*Years?\s*(\d+)?\s*Months?/i);
  if (exp) {
    const years = exp[1] || "0";
    const months = exp[2] || "0";
    setYears(years);
    setMonths(months);
  }
}
    console.log("Fetched submission details:", data);
 setCurrentSubmissionGuid(data.submissionGuid);
  setSelectedJobTitleId(data.jobTitleID || "");
setSubmittedBy(data.submittedBy || "");
setValue("SubmittedBy", data.submittedBy || "");

setValue("Comments", data.comments || "");

    reset({
payRate: data.payRate
  ? data.payRate.replace(/rs\.?/i, "").replace(/\$/g, "").replace(/[^\d]/g, "")
  : "",
BillRate: data.billRate
  ? data.billRate.replace(/rs\.?/i, "").replace(/\$/g, "").replace(/[^\d]/g, "")
  : "",

      jobRole: data.jobRole|| "",
      VendorGuid: data.vendorGuid || "",
      jobPost: data.jobTitleID || "",
      clientStatus: data.clientStatus || "Submitted",
      technicalSkill: data.technicalSkill || "",
      workMode: data.workMode || "",
      ProfileSummery: data.profileSummery || "",
      SubmittedBy:  data.SubmittedBy || "",     
      Comments: data.comments || "",

  AvailabilityToJoin: data.availabilityToJoin || data.AvailabilityToJoin || "",
  AvailabilityToInterview: data.availabilityToInterview || data.AvailabilityToInterview || "",
  WillingToRelocate:
  data.willingToRelocate?.toString(),

  Tworefrencesfromrecentproject: data.tworefrencesfromrecentproject || data.tworefrencesfromrecentproject || "",
    documents: [],
    });
    // Now set experience from submission
if (data.experience) {
  const exp = data.experience.trim();

  const yearMatch = exp.match(/(\d+)\s*Years?/i);
  const monthMatch = exp.match(/(\d+)\s*Months?/i);

  const y = yearMatch ? yearMatch[1] : "";
  const m = monthMatch ? monthMatch[1] : "";

   handleExperienceChange(y, m);
}
    // ✅ After reset({...})
if (data.skillMetrics) {
  try {
    setSkills(JSON.parse(data.skillMetrics));
  } catch {
    setSkills([{ Skill: "", YearsOfExp: "", Rating: "" }]);
  }
} else {
  setSkills([{ Skill: "", YearsOfExp: "", Rating: "" }]);
}

// ✅ Handle custom assessment link/file display
if (data.customAssessmentLink) {
  setAssessmentMode("link");
  setValue("customAssessmentLink", data.customAssessmentLink);
} else if (data.customAssessmentFile) {
  setAssessmentMode("file");
  setAssessmentFile(data.customAssessmentFile);
} else {
  setAssessmentMode("");
  setAssessmentFile(null);
}

// 👇 Trigger dependent dropdown once values are reset
if (data.jobRole && data.vendorGuid) {
  await fetchJobPosts(data.jobRole, data.vendorGuid);
}
setUploadedFiles({

  // 🧾 Resume

  Resume:

    data.fileUrl && data.fileUrl.trim() !== ""

      ? data.fileUrl

      : data.resume && data.resume.trim() !== ""

      ? data.resume

      : null,
 
  // 📄 RTR

  RTR_PDF:

    data.rtR_PDFDoc && data.rtR_PDFDoc.trim() !== ""

      ? data.rtR_PDFDoc

      : data.rtR_PDF && data.rtR_PDF.trim() !== ""

      ? data.rtR_PDF

      : null,
 
  // 📘 Resume Insights

  Resume_Insights_Pdf:

    data.resume_Insights_Pdfdoc && data.resume_Insights_Pdfdoc.trim() !== ""

      ? data.resume_Insights_Pdfdoc

      : data.resume_Insights_Pdf && data.resume_Insights_Pdf.trim() !== ""

      ? data.resume_Insights_Pdf

      : null,
 
  // 📂 Others

  Others:

    data.othersDoc && data.othersDoc.trim() !== ""

      ? data.othersDoc

      : data.others && data.others.trim() !== ""

      ? data.others

      : null,
 
  // 🪪 Visa Copy

  visaCopy:

    data.visaCopyUrl && data.visaCopyUrl.trim() !== ""

      ? data.visaCopyUrl

      : data.visaCopy && data.visaCopy.trim() !== ""

      ? data.visaCopy

      : null,
 
  // 🚗 Driving Licence

  drivingLicence:

    data.drivingLicenceUrl && data.drivingLicenceUrl.trim() !== ""

      ? data.drivingLicenceUrl

      : data.drivingLicence && data.drivingLicence.trim() !== ""

      ? data.drivingLicence

      : null,
 
  // 🛂 Passport

  passport:

    data.passportURL && data.passportURL.trim() !== ""

      ? data.passportURL

      : data.passport && data.passport.trim() !== ""

      ? data.passport

      : null,
 
  // 📑 I-94

  i94:

    data.i94File && data.i94File.trim() !== ""

      ? data.i94File

      : data.i94 && data.i94.trim() !== ""

      ? data.i94

      : null,

});

 



  } catch (err) {
    console.error("Error fetching submission:", err);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to fetch submission details. Please try again.",
    });
  }
};



    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= userguid
    }
    const [candidateDetails, setCandidateDetails] = useState(null);
    const [jobRoles, setJobRoles] = useState([]);
    const [qualifications, setQualifications] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState({ title: "", url: "" });
const { register, handleSubmit, reset, watch, setValue, formState: { errors } } = useForm({
  defaultValues: {
    payRate: candidateDetails?.payRate || "",
    jobRole: candidateDetails?.jobRole || "",
    vendor: "",
    jobTitle: "",
    experience: candidateDetails?.experience || "",
    clientStatus: "",
    documents: []
  }
});
  const [years, setYears] = useState("");
  const [months, setMonths] = useState("");
  const [vendorData, setVendorData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDocType, setSelectedDocType] = useState(null);
  const [documents,SetDocuments] =useState([{}]);
    const [uploadedFiles, setUploadedFiles] = useState({});
      const [jobPosts, setJobPosts] = useState([]);    
      const [showModal1, setShowModal1] = useState(false);
       const jobTitleOptions = jobPosts.map(job => ({
        value: job.jobPostID,
        label: `${job.title} - ${job.clientName}`,
        jobDescription: job.jobDescription ,// Store job description for later use
        billRate: job.billRate,
      }));
  
const saveCandidateAudio = async (candidateGuid, candidateName, audioFile, audioValue) => {
  const audioForm = new FormData();
  audioForm.append("Guid", candidateGuid);
  audioForm.append("CandidateName", candidateName);
  audioForm.append("Audio", audioFile);
  audioForm.append("AudioUrl", audioFile?.name || "");
  audioForm.append("FileId", audioValue || "");

  try {
    await Axios.post(SaveCandidateRecordedAudio.APIURL, audioForm, {
      headers: { "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`
       },
    });
  } catch (err) {
    console.error("Save audio failed:", err);
  }
};

  const documentLabels = {
    FileUrl: "Resume",
    VisaCopyUrl: "Visa Copy",
    DrivingLicenceUrl: "Driving Licence",
    PassportURL: "Passport",
    I94File: "I-94",
     RTR_PDFDoc:"RTR_PDF",
    Resume_Insights_Pdfdoc:"Resume_Insights_Pdf",
    OthersDoc:"Others"
  };
   const [workmode, setWorkMode] = useState([
      { statusID: "1", statusName: "Work from Home" },
      { statusID: "2", statusName: "Work from Office" },
      { statusID: "3", statusName: "Hybrid" }])
      const [submissionData, setSubmissionData] = useState({});

useEffect(() => {
  if (candidateDetails) {
    reset({
      payRate: candidateDetails.payRate || "",
      jobRole: candidateDetails.jobRole || "",
      experience: candidateDetails.experience || "",
      vendor: "",
      jobTitle: "",
      clientStatus: "",
      documents: []
    });
  }
}, [candidateDetails]);
useEffect(() => {
  if (isEditing && submissionData) {
    // Populate fields
    reset({
      technicalSkill: submissionData.technicalSkill || "",
      vendorName: submissionData.vendorName || "",
      clientStatus: submissionData.clientStatus || "",
      payRate: submissionData.payRate || "",
      billRate: submissionData.billRate || "",
    });
  }
}, [submissionData, isEditing, reset]);
 const handleExperienceChange = (y, m) => {
  setYears(y);
  setMonths(m);

  let expText = "";

  if (y && !m) expText = `${y} Years`;
  else if (!y && m) expText = `${m} Months`;
  else if (y && m) expText = `${y} Years ${m} Months`;
  else expText = "";

  setValue("experience", expText);
};

    const fetchJobRoles = async () => {
    const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
        try {
            const response = await Axios.get(getApiUrl);
            setJobRoles(response.data);
        } catch (error) {
            console.error("Error fetching job roles", error);
        }
    };
      const handleShowModal1 = async (docTypeKey, file) => {
      if (!file) return;
    
      let fileName = "";
      let blobUrl = "";
    
      if (file instanceof File) {
        fileName = file.name.toLowerCase();
        blobUrl = URL.createObjectURL(file);
      } else if (typeof file === "string") {
        fileName = file.split("/").pop().toLowerCase();
        blobUrl = file;
      } else {
        console.error("Unknown file type");
        return;
      }
    
     if (fileName.endsWith(".docx")) {
      if (file instanceof File) {
        try {
          const arrayBuffer = await file.arrayBuffer();
          const { value } = await mammoth.convertToHtml({ arrayBuffer });
          setModalContent({
            title: documentLabels[docTypeKey] || docTypeKey,
            html: value,
            url: null,
            file: file,
          });
        } catch (error) {
          console.error("DOCX preview error", error);
          setModalContent({
            title: documentLabels[docTypeKey] || docTypeKey,
            html: "<p>Failed to render DOCX preview.</p>",
            url: null,
            file: file,
          });
        }
      } else if (typeof file === "string") {
        // ✅ Set the URL so Office viewer iframe can use it
        setModalContent({
          title: documentLabels[docTypeKey] || docTypeKey,
          html: null,
          url: file, // ✅ not null anymore
          file: null,
        });
      } else {
        console.error("Invalid DOCX file type");
        setModalContent({
          title: documentLabels[docTypeKey] || docTypeKey,
          html: "<p>Cannot preview this DOCX file.</p>",
          url: null,
          file: null,
        });
      }
    }
    else {
      setModalContent({
        title: documentLabels[docTypeKey] || docTypeKey,
        html: null,
        url: file,
        file: null,
      });
    }
    
      setShowModal1(true);
    };
    
    const handleCloseModal1 = () => {
      setShowModal1(false);
    };
   
const handleRemoveFile = async (docTypeKey) => {
  const fileToDelete = uploadedFiles[docTypeKey];
  if (!fileToDelete) return;

  const confirmDelete = await Swal.fire({
    title: "Are you sure?",
    text: "Do you want to remove this document?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, remove it!",
  });

  if (!confirmDelete.isConfirmed) return;

  try {
    // ✅ Don’t delete from blob; just clear that document type
    const updatedFiles = { ...uploadedFiles };
    updatedFiles[docTypeKey] = null;

    setUploadedFiles(updatedFiles);

    Swal.fire({
      icon: "success",
      title: "Removed!",
      text: `${docTypeKey} has been cleared.`,
      timer: 2000,
      showConfirmButton: false,
    });
  } catch (error) {
    console.error("Error removing file:", error);
    Swal.fire({
      icon: "error",
      title: "Failed",
      text: "Unable to clear the document. Please try again.",
    });
  }
};

 const fetchcodocumenttypes= async()=>
    {
      const GetapiUrl=GetDocumentTypes.APIURL;
      const fetchJSON = async () => {
        const response = await fetch(GetapiUrl);
        let json = await response.json();
        SetDocuments(json);
      }
      fetchJSON();
  }
    const fetchQualifications = async () => {
        const getApiUrl = GetCourseInfo.APIURL;
        try {
            const response = await Axios.get(getApiUrl);
            setQualifications(response.data);
        } catch (error) {
            console.error("Error fetching qualifications", error);
        }
    };

    const GetCandidateDetails = async () => {
        const GetapiUrl = GetCandidateById.APIURL;
        const params = { guid: guid };

         try {
    const result = await Axios.post(GetapiUrl, params);
    setCandidateDetails(result.data);

    // ✅ place your setUploadedFiles HERE (inside try block, right after setCandidateDetails)
    setUploadedFiles({
      FileUrl: result.data?.fileUrl || null,
      VisaCopyUrl: result.data?.visaCopyUrl || null,
      DrivingLicenceUrl: result.data?.drivingLicenceUrl || null,
      PassportURL: result.data?.passportURL || null,
      I94File: result.data?.i94File || null,
      RTR_PDFDoc: result.data?.rtR_PDFDoc || null,
      Resume_Insights_Pdfdoc: result.data?.resume_Insights_Pdfdoc || null,
      OthersDoc: result.data?.othersDoc || null
      
    });
if (result.data?.experience) {
  const exp = result.data.experience.trim();

  const yearMatch = exp.match(/(\d+)\s*Years?/i);
  const monthMatch = exp.match(/(\d+)\s*Months?/i);

  const y = yearMatch ? yearMatch[1] : "";
  const m = monthMatch ? monthMatch[1] : "";

  // 👇 Use your actual function
  handleExperienceChange(y, m);
}

  } catch (error) {
    console.error("Error fetching candidate details:", error);
  }
    };

    const handleShowModal = (title, url) => {
        setModalContent({ title, url });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };
const GetVendorsList = async() => {
  setIsLoading(true);

  const GetapiUrl = GetListOfVendorsByEmployeeID.APIURL + `?UserGuid=${Guid}&CountryID=${selectedCountry}`;

 await Axios.get(GetapiUrl)
    .then((result) => {
      setIsLoading(false);

      setVendorData(result.data);
    }).catch((error) => {
      console.log("Error" + error);
    });
};
console.log("vendorData", vendorData);
useEffect(() => {
  const initializeData = async () => {
    try {
      await fetchJobRoles();
      await fetchQualifications();
      await GetCandidateDetails();
      await GetVendorsList();
      await fetchcodocumenttypes();
      await fetchSubmissions();
      await GetUsersList();
    } catch (error) {
      console.error("Error initializing data:", error);
    }
  };

  initializeData();
}, [selectedCountry]);


   // Watch form fields FIRST
const selectedJobRole = watch("jobRole");
const selectedVendorGuid = watch("VendorGuid");

// Then use them safely inside useEffect
useEffect(() => {
  if (selectedJobRole && selectedVendorGuid) {
    fetchJobPosts(parseInt(selectedJobRole), selectedVendorGuid);
  } else {
    setJobPosts([]); // clear if either is not selected
  }
}, [selectedJobRole, selectedVendorGuid]);


const fetchJobPosts = async (jobRoleId, vendorGuid) => {
  setIsLoading(true);
  try {
    const response = await Axios.get(`${GetJobPosts.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
// Filter based on selected Job Role and Vendor (client)
    const filteredPosts = response.data.filter((post) =>
      post.jobRoleID == jobRoleId && post.vGuid == vendorGuid&&
       post.status=="Active"
    );
        console.log(filteredPosts)

    setJobPosts(filteredPosts);
  } catch (error) {
    console.error("Error fetching job posts", error);
  } finally {
    setIsLoading(false);
  }
};
   
    
    const getExperienceText = (experience) => {
        if (!experience) return '';
        return experience?.toLowerCase().includes('years') ? experience : `${experience} years`;
      };
      
    const getJobRoleName = (id) => {
        const jobRole = jobRoles.find(role => role.jobRoleId == id);
        return jobRole ? jobRole.jobRole : "";
    };

    const getQualificationName = (id) => {
        const qualification = qualifications.find(q => q.qualificationID == id);
        return qualification ? qualification.courseName : "";
    };

const renderAttachment = (url, file, html) => {
  if (html) {
    return (
      <div
        style={{ maxHeight: "500px", overflowY: "auto" }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }

  // ✅ Handle both File objects and string URLs safely
  let name = "";
  if (file && file.name) {
    name = file.name.toLowerCase();
  } else if (typeof url === "string") {
    name = url.split("/").pop()?.toLowerCase() || "";
  } else {
    console.warn("Invalid URL or file type passed to renderAttachment:", url);
    return <div>File not found or unsupported format.</div>;
  }

  // ✅ Fallback check
  if (!url && !file) {
    return <div>File not found.</div>;
  }

  const fileUrl =
    typeof url === "string"
      ? url
      : file
      ? URL.createObjectURL(file)
      : null;

  if (!fileUrl) {
    return <div>File not found.</div>;
  }

  // ✅ PDF
  if (name.endsWith(".pdf")) {
    return (
      <iframe
        src={fileUrl}
        style={{ width: "100%", height: "500px", border: "none" }}
        title="PDF Preview"
      />
    );
  }

  // ✅ Image
  if (name.endsWith(".jpg") || name.endsWith(".jpeg") || name.endsWith(".png")) {
    return <img src={fileUrl} alt="preview" style={{ maxWidth: "100%" }} />;
  }

  // ✅ HTML
  if (name.endsWith(".html") || name.endsWith(".htm")) {
    return (
      <iframe
        src={fileUrl}
        title="HTML Preview"
        style={{ width: "100%", height: "500px", border: "none" }}
      />
    );
  }

  // ✅ DOCX
  if (name.endsWith(".docx")) {
    if (typeof fileUrl === "string" && fileUrl.startsWith("https")) {
      return (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`}
          title="DOCX Preview"
          style={{ width: "100%", height: "500px", border: "none" }}
        />
      );
    } else {
      return (
        <div>
          <p>
            DOCX preview not supported for local files.{" "}
            <a href={fileUrl} target="_blank" rel="noreferrer">
              Download
            </a>
          </p>
        </div>
      );
    }
  }

  return (
    <div>
      <p>
        Preview not supported for this file type.{" "}
        <a href={fileUrl} target="_blank" rel="noreferrer">
          Download
        </a>
      </p>
    </div>
  );
};

const safeValue = (value) => 
  (value === null || value === undefined || value === "null" || value === "undefined") 
    ? "" 
    : value;

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    };
const handleDownload = (url) => {
  const fileExtension = url.split('.').pop().toLowerCase();

  const link = document.createElement("a");
  link.href = url;

   if (["pdf", "html", "htm"].includes(fileExtension)) {
    // open in a new tab instead of downloading
    link.target = "_blank";
  } else {
    // force download for other file types
    link.setAttribute("download", "");
  }

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


  const handleDeleteSubmission = async (submissionId) => {

    try {
      setIsLoading(true);
      const result = await Axios.delete(`${DeleteCandidateSubmission.APIURL}?submissionGuid=${submissionId}`,
        {
              headers:{
                  Authorization: `Bearer ${token}`
              }
            }
      );
      
      if (result.data === 'Deleted successfully.') {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Deleted successfully',
          showConfirmButton: false,
          timer: 2000,
        });
        fetchSubmissions();
        setIsLoading(false);
        setShowModal(false);
      }
    } catch (error) {
      console.log("Error", error);
      setIsLoading(false);
    }
  };



const [currentSubmissionGuid, setCurrentSubmissionGuid] = useState(null);
const onSubmit = async (data) => {
  try {
    setIsLoading(true);

    // 🧩 Prepare multipart form data
    const formData = new FormData();
const finalJobTitleId = data.jobPost || selectedJobTitleId;
    // Basic required fields
    if (isEditing && currentSubmissionGuid) {
  formData.append("SubmissionGuid", currentSubmissionGuid); // ✅ actual guid from API
} else {
  formData.append("SubmissionGuid", '00000000-0000-0000-0000-000000000000'); // ✅ for new submission
} // Empty as per spec
    formData.append("CandidateGuid", guid);
    formData.append("CandidateID", candidateDetails?.candidatesID || "");
    formData.append("JobRoleID", data.jobRole || "");
    formData.append("VendorGuid", data.VendorGuid || "");
    formData.append("TechnicalSkill", data.technicalSkill || "");
    formData.append("Experience", data.experience || "");
    formData.append("WorkMode", data.workMode || "");
    formData.append("ProfileSummery", data.ProfileSummery || "");
    formData.append("JobTitleID", finalJobTitleId || "");
    formData.append("ClientStatus", data.clientStatus || "");
 formData.append("SubmittedBy", data.SubmittedBy || submittedBy || email);
formData.append("SkillMetrics", data.SkillMetrics || JSON.stringify(skills || [])); // JSON string expected
formData.append("AvailabilityToInterview", data.AvailabilityToInterview || "");
formData.append("AvailabilityToJoin", data.AvailabilityToJoin || "");
// WillingToRelocate may be boolean or "Yes"/"No" — adapt if backend expects boolean
formData.append("WillingToRelocate", data.WillingToRelocate);
formData.append("TwoReferencesFromRecentProject", data.Tworefrencesfromrecentproject || data.TwoReferencesFromRecentProject || "");
formData.append("CustomAssessmentLink", data.customAssessmentLink || "");
formData.append("comments", data.Comments || "");

// inside onSubmit before appending PayRate and BillRate
const formatRate = (value, isUSD) => {
  if (!value) return "";

  const trimmedValue = value.toString().trim();

  // ✅ Detect if already has Rs, $, INR, or USD
  const hasCurrency = /(\$|rs\.?|inr|usd)/i.test(trimmedValue);
  if (hasCurrency) return trimmedValue;

  // ✅ Add appropriate prefix
  return isUSD ? `$${trimmedValue}` : `Rs.${trimmedValue}`;
};


// ✅ use it as before
formData.append("PayRate", formatRate(data.payRate, selectedCountry == 2));
formData.append("BillRate", formatRate(data.BillRate, selectedCountry == 2));

    formData.append("CreatedBy", email);

  // 🧾 Handle uploaded documents (send actual file names)
// ✅ Enhanced version — keeps previously fetched docs if user doesn't upload new ones
const appendFilePair = (labelKey, binaryKey, localKey) => {
  let file = uploadedFiles[localKey];

  // ✅ 1. If new file is uploaded now
  if (file instanceof File) {
    formData.append(labelKey, file.name);
    formData.append(binaryKey, file, file.name);
    return;
  }

  // ✅ 2. If file already exists in uploadedFiles as a URL
  if (typeof file === "string" && file.trim() !== "") {
    const filename = file.split("/").pop();
    formData.append(labelKey, filename);
    formData.append(binaryKey, file);
    return;
  }

  // ✅ 3. If editing & user didn’t touch this doc, reuse from last fetched submission
  if (isEditing && submissionData) {
    // map your API field names to your formData keys
    const previousFiles = {
      Resume: submissionData.fileUrl,
      RTR_PDF: submissionData.rtR_PDFDoc,
      Resume_Insights_Pdf: submissionData.resume_Insights_Pdfdoc,
      Others: submissionData.othersDoc,
      VisaCopy: submissionData.visaCopyUrl,
      DrivingLicence: submissionData.drivingLicenceUrl,
      Passport: submissionData.passportURL,
      I94: submissionData.i94File
    };

    const existingUrl = previousFiles[labelKey];
    if (existingUrl && existingUrl.trim() !== "") {
      const filename = existingUrl.split("/").pop();
      formData.append(labelKey, filename);
      formData.append(binaryKey, existingUrl);
      return;
    }
  }

  // ✅ 4. Nothing found — send empty strings
  formData.append(labelKey, "");
  formData.append(binaryKey, "");
};



// Match keys to API field names
appendFilePair("Resume", "FileUrl", "Resume");
appendFilePair("RTR_PDF", "RTR_PDFDoc", "RTR_PDF");
appendFilePair("Resume_Insights_Pdf", "Resume_Insights_Pdfdoc", "Resume_Insights_Pdf");
appendFilePair("Others", "OthersDoc", "Others");
appendFilePair("VisaCopy", "VisaCopyUrl", "Visa Copy");
appendFilePair("DrivingLicence", "DrivingLicenceUrl", "Driving Licence");
appendFilePair("Passport", "PassportURL", "Passport");
appendFilePair("I94", "I94File", "I-94");


const apiurl = isEditing ? UpdateCandidateSubmissions.APIURL : AddCandidateSubmissions.APIURL
    // ✅ Send to API
    const response = await axios.post(
      apiurl,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data",
                     Authorization: `Bearer ${token}`
         },

      }
    );
if (assessmentMode === "file" && assessmentFile) {
  await saveCandidateAudio(
    currentSubmissionGuid,
    candidateDetails?.fullName,
    assessmentFile,
    audioValue
  );
}
    // ✅ Success handling
    if (response.data.message == "Record created successfully" ) {
      setShowSubmissionForm(false);
        fetchSubmissions();
      await Swal.fire({
        title: "✅ Success!",
        text: "Submission created successfully.",
        icon: "success",
        confirmButtonColor: "#28a745",
      });
      reset();
      setUploadedFiles({});
      setSelectedDocType("");
    } 
      else if (response.data.message == "Record updated successfully" ) {
      setShowSubmissionForm(false);
        fetchSubmissions();
      await Swal.fire({
        title: "✅ Success!",
        text: "Submission updated successfully.",
        icon: "success",
        confirmButtonColor: "#28a745",
      });
      reset();
      setUploadedFiles({});
      setSelectedDocType("");
    } 
    else if (response.data.message == "Record not created" ) {
      await Swal.fire({
        title: "⚠️ Error",
        text: "Something went wrong while saving the submission.",
        icon: "error",
        confirmButtonColor: "#dc3545",
      });
    }
  } catch (error) {
    console.error("❌ API Error:", error);
    await Swal.fire({
      title: "❌ Error",
      text: error.response?.data?.message || "Failed to submit candidate data.",
      icon: "error",
      confirmButtonColor: "#dc3545",
    });
  } finally {
    setIsLoading(false);
  }
};
  const handleChange = (index, field, value) => {
    const updated = [...skills];
    updated[index][field] = value;
    setSkills(updated);

    // Keep API value updated as stringified JSON
    setValue("SkillMetrics", JSON.stringify(updated));
  };
  const handleAdd = () => {
    setSkills([...skills, { Skill: "", YearsOfExp: "", Rating: "" }]);
  };
  const handleDelete = (index) => {
    const updated = skills.filter((_, i) => i !== index);
    setSkills(updated);
    setValue("SkillMetrics", JSON.stringify(updated));
  };
    return (
      
        <ConsultantLayout>
          <style>
  {`.custom-modal-dialog {
  max-width: 90vw !important; /* 90% of screen width */
}

/* Modal content box */
.custom-modal-dialog .modal-content {
  height: 90vh; /* 90% of screen height */
  display: flex;
  flex-direction: column;
}

/* Header and footer stay fixed */
.custom-modal-dialog .modal-header,
.custom-modal-dialog .modal-footer {
  flex-shrink: 0;
}

/* 🟢 Scrollable body section */
.custom-modal-body {
  flex-grow: 1;
  overflow-y: auto;
  max-height: calc(90vh - 120px); /* Leaves space for header/footer */
  padding-right: 12px; /* Avoid scrollbar overlap */
}
`}
          </style>
            {candidateDetails ? (
                <div className="container-fluid">
                    <CandidateLayout1 title=" Internal Bench Candidate Details" candidateGuid={guid} fullName= {candidateDetails?.fullName} email={candidateDetails?.email}/>
                    <hr />
                    
                    <Accordion defaultActiveKey="0" className="mt-1">
  <Accordion.Item eventKey="0">
    <Accordion.Header>
      <i className="fa fa-user text-info mr-2"></i> Candidate Details
    </Accordion.Header>
    <Accordion.Body>
 <div className="card shadow-lg mt-2 pl-5 pr-5 pt-2 " style={{ border: "none" }}>
                        <div className="row mt-2">
                            
                            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-fullName">Full Name</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-user icons"></i> {candidateDetails.fullName}</p>
                                </OverlayTrigger>
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Email</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-envelope icons"></i> {candidateDetails.email}</p>
                                </OverlayTrigger>
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-mobileNumber">Mobile Number</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-phone icons"></i> {candidateDetails.mobileNumber}</p>
                                </OverlayTrigger>
                    
                                                
                               {candidateDetails.gender !=null &&   candidateDetails.gender !== "null" && 
                               (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-gender">Gender</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-venus-mars icons"></i> {candidateDetails.gender}</p>
                                </OverlayTrigger>)}

                              {candidateDetails.address !=null &&   candidateDetails.address  !== "null" &&
                              ( <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-address">Address</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-map-marker icons"></i> {candidateDetails.address}</p>
                                </OverlayTrigger>)}
                                {candidateDetails.dob  != null &&   candidateDetails.dob  !== "null" &&
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-dob">Date of Birth</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-birthday-cake icons"></i> {candidateDetails.dob}</p>
                                </OverlayTrigger>)}
                                {candidateDetails.maritalStatus != null &&   candidateDetails.maritalStatus !== "null" &&  
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-maritalStatus">Marital Status</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-heart icons"></i> {capitalizeFirstLetter(candidateDetails.maritalStatus)}</p>
                                </OverlayTrigger>)}
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-experience">Experience</Tooltip>}>
        <p className="text-para"><i className="fa fa-briefcase icons"></i> {getExperienceText(candidateDetails.experience)}</p>
      </OverlayTrigger>
      {/* {candidateDetails.preferLocation != null &&   candidateDetails.preferLocation !== "null" &&  
                                 <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-preferLocation">Country</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-map icons"></i>     {candidateDetails.preferLocation === "1" ? "India" : "United States"}</p>
                                </OverlayTrigger>} */}
                                {candidateDetails.technicalSkill != null &&   candidateDetails.technicalSkill !== "null" &&  
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-technicalSkill">Technical Skill</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-cogs icons"></i> {candidateDetails.technicalSkill}</p>
                                </OverlayTrigger>}
                                  {candidateDetails.highestEducation !=null &&   candidateDetails.highestEducation !== "null" && 
                               (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-gender">Highest Education</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-graduation-cap icons"></i> {candidateDetails.highestEducation}</p>
                                </OverlayTrigger>)}
                             
                                   
                                {selectedCountry == 2 &&
  candidateDetails.workAuthorizationandValidity !== null &&
  candidateDetails.workAuthorizationandValidity !== "null" && (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Tooltip id="tooltip-technicalSkill">
          Work Authorization and Validity
        </Tooltip>
      }
    >
      <p className="text-para">
        <i className="fa fa-cogs icons"></i> {candidateDetails.workAuthorizationandValidity}
      </p>
    </OverlayTrigger>
)}

  {candidateDetails.candidateType  !== null && candidateDetails.candidateType !== "null"  && (      
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">Candidate Type</Tooltip>}>
                                    <p className="text-para"><i className="fas fa-hourglass-half icons"></i> {safeValue(candidateDetails.candidateType)}</p>
                                </OverlayTrigger>)}

                                {candidateDetails.employerName !== null && candidateDetails.employerName!== "null" && 
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-technicalSkill">Employer Name</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-cogs icons"></i> {candidateDetails.employerName}</p>
                                </OverlayTrigger>}
                                
                                {candidateDetails.ssn !== null && candidateDetails.ssn !== "null" && 
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">SSN</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-building icons"></i> {candidateDetails.ssn}</p>
                                </OverlayTrigger>)}
                                {candidateDetails.passportNo !== null && candidateDetails.passportNo !== "null" && 
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">Passport Number</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-id-card icons"></i> {candidateDetails.passportNo}</p>
                                </OverlayTrigger>)}
     {internalSubmission?.comments &&
 internalSubmission.comments !== "null" && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-comments">Comments</Tooltip>}>
      <p className="text-para"><i className="fa fa-comment icons"></i> {internalSubmission.comments}</p>
  </OverlayTrigger>
)}
{internalSubmission?.tworefrencesfromrecentproject &&
 internalSubmission.tworefrencesfromrecentproject !== "null" && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-refs">References from Recent Project</Tooltip>}>
      <p className="text-para"><i className="fa fa-users icons"></i> 
        {internalSubmission.tworefrencesfromrecentproject}
      </p>
  </OverlayTrigger>
)}


                 
                 </div>
                            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                      
                                {candidateDetails.createdBy  !== null && candidateDetails.createdBy !== "null"  && (      
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">CreatedBy</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-user icons"></i> {candidateDetails.createdBy}</p>
                                </OverlayTrigger>)}
                             
  {candidateDetails.priority !== null && candidateDetails.priority !== "null" && (
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip-workMode">Priority</Tooltip>}
  >
    <p className="text-para">
      <i className="fa fa-building icons"></i>    {candidateDetails.priority }
    </p>
  </OverlayTrigger>
)}

{candidateDetails.profileSummery !== null && candidateDetails.profileSummery !== "null" && ( 
<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-profileSummery">Profile Summary</Tooltip>}>
    <p className="text-para"><i className="fa fa-info-circle icons"></i> {candidateDetails.profileSummery}</p>
</OverlayTrigger>)}
{(candidateDetails.jobRole !== null && candidateDetails.jobRole !== 0 && candidateDetails.jobRole !== "null" ) && (
    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-jobRole">Job Role</Tooltip>}>
        <p className="text-para"><i className="fa fa-briefcase icons"></i> {getJobRoleName(candidateDetails.jobRole)}</p>
    </OverlayTrigger>
)}

{(candidateDetails.qualificationID !== null && candidateDetails.qualificationID !== 0 && candidateDetails.qualificationID !== "null") && (
    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-qualification">Qualification</Tooltip>}>
        <p className="text-para"><i className="fa fa-graduation-cap icons"></i> {getQualificationName(candidateDetails.qualificationID)}</p>
    </OverlayTrigger>
)}

{candidateDetails.linkedInUrl !== null && candidateDetails.linkedInUrl !== "null" && (
    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-qualification">LinkedIn Url</Tooltip>}>
        <a 
            href={candidateDetails.linkedInUrl?.startsWith('http') ? candidateDetails.linkedInUrl : `https://${candidateDetails.linkedInUrl}`} 
            target="_blank" 
            rel="noopener noreferrer"
        >
            <p className="text-para">
                <i className="fa fa-graduation-cap icons mr-1"></i>
                {candidateDetails.linkedInUrl}
            </p>
        </a>
    </OverlayTrigger>
)}
{internalSubmission?.vendorName && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-vendorName">Vendor Name</Tooltip>}>
      <p className="text-para"><i className="fa fa-building icons"></i> {internalSubmission.vendorName}</p>
  </OverlayTrigger>
)}
{internalSubmission?.vendorCompanyName && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-vendorCompany">Vendor Company</Tooltip>}>
      <p className="text-para"><i className="fa fa-building icons"></i> {internalSubmission.vendorCompanyName}</p>
  </OverlayTrigger>
)}
{internalSubmission?.availabilityToInterview && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-availabilityInterview">Availability to Interview</Tooltip>}>
      <p className="text-para"><i className="fa fa-clock icons"></i> {internalSubmission.availabilityToInterview}</p>
  </OverlayTrigger>
)}
{internalSubmission?.availabilityToJoin && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-availabilityJoin">Availability to Join</Tooltip>}>
      <p className="text-para"><i className="fa fa-calendar-check icons"></i> {internalSubmission.availabilityToJoin}</p>
  </OverlayTrigger>
)}

{candidateDetails.address && candidateDetails.address !== "null" && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-cityState">State & City</Tooltip>}>
    <p className="text-para"><i className="fa fa-map-pin icons"></i> 
      {candidateDetails.address.split(" - ")[1]} - {candidateDetails.address.split(" - ")[2]}
    </p>
  </OverlayTrigger>
)}
{candidateDetails.certifications &&
 candidateDetails.certifications !== "null" && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-certifications">Certifications</Tooltip>}>
      <p className="text-para"><i className="fa fa-certificate icons"></i> {candidateDetails.certifications}</p>
  </OverlayTrigger>
)}
{internalSubmission?.willingToRelocate && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-relocate">Willing To Relocate</Tooltip>}>
      <p className="text-para"><i className="fa fa-map-pin icons"></i> {internalSubmission.willingToRelocate}</p>
  </OverlayTrigger>
)}
{internalSubmission?.workMode && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">Work Mode</Tooltip>}>
      <p className="text-para"><i className="fa fa-building icons"></i> {internalSubmission.workMode}</p>
  </OverlayTrigger>
)}
{internalSubmission?.marketingStatus && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">Marketing Status</Tooltip>}>
      <p className="text-para"><i className="fa fa-building icons"></i> {internalSubmission.marketingStatus}</p>
  </OverlayTrigger>
)}
{internalSubmission?.jobLocation && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-jobLocation">Job Location</Tooltip>}>
      <p className="text-para"><i className="fa fa-map-marker icons"></i> {internalSubmission.jobLocation}</p>
  </OverlayTrigger>
)}
{internalSubmission?.jobMode && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-jobMode">Job Mode</Tooltip>}>
      <p className="text-para"><i className="fa fa-briefcase icons"></i> {internalSubmission.jobMode}</p>
  </OverlayTrigger>
)}
{internalSubmission?.billRate && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-billRate">Bill Rate</Tooltip>}>
      <p className="text-para"><i className="fa fa-dollar-sign icons"></i> {internalSubmission.billRate}</p>
  </OverlayTrigger>
)}
{internalSubmission?.payRate && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-payRate">Pay Rate</Tooltip>}>
      <p className="text-para"><i className="fa fa-money-bill icons"></i> {internalSubmission.payRate}</p>
  </OverlayTrigger>
)}
{internalSubmission?.customAssessmentLink && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-assessment">Custom Assessment</Tooltip>}>
      <p className="text-para">
        <i className="fa fa-link icons"></i>
        <a href={internalSubmission.customAssessmentLink} target="_blank">View Assessment</a>
      </p>
  </OverlayTrigger>
)}



{/* 🔹 Attachments Header */}
{hasAttachments && (
  <h2 style={{ color: "#00a7ac", marginLeft: "10px", marginBottom: "2", marginTop: "0" }}>
    Attachments
  </h2>
)}

{/* 🔹 Resume */}
{internalSubmission?.fileUrl && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-resume">Resume</Tooltip>}>
    <p className="text-para">
      <a href="#" style={{ fontSize: 18 }}
        onClick={() => handleShowModal("Resume", internalSubmission.fileUrl)}>
        <i className="fa fa-file-alt icons"></i> View Resume
      </a>
      &nbsp;|&nbsp;
      <a href="#"
        style={{ fontSize: 18 }}
        onClick={(e) => {
          e.preventDefault();
          handleDownload(internalSubmission.fileUrl, candidateDetails.fullName, "Resume");
        }}>
        <i className="fa fa-download icons"></i> Download Resume
      </a>
    </p>
  </OverlayTrigger>
)}

{/* 🔹 RTR PDF */}
{internalSubmission?.rtR_PDFdoc && internalSubmission.rtR_PDFdoc !== "" && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-rtr">RTR</Tooltip>}>
    <p className="text-para">
      <a href="#"
        style={{ fontSize: 18 }}
        onClick={() => handleShowModal("RTR", internalSubmission.rtR_PDFdoc)}>
        <i className="fa fa-file icons"></i> View RTR
      </a>
      &nbsp;|&nbsp;
      <a href="#"
        style={{ fontSize: 18 }}
        onClick={(e) => {
          e.preventDefault();
          handleDownload(internalSubmission.rtR_PDFdoc, candidateDetails.fullName, "RTR");
        }}>
        <i className="fa fa-download icons"></i> Download RTR
      </a>
    </p>
  </OverlayTrigger>
)}

{/* 🔹 Resume Insights */}
{internalSubmission?.resume_Insights_Pdfdoc && internalSubmission.resume_Insights_Pdfdoc !== "" && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-insights">Resume Insights</Tooltip>}>
    <p className="text-para">
      <a href="#"
        style={{ fontSize: 18 }}
        onClick={() => handleShowModal("Resume Insights", internalSubmission.resume_Insights_Pdfdoc)}>
        <i className="fa fa-file-alt icons"></i> View Resume Insights
      </a>
      &nbsp;|&nbsp;
      <a href="#"
        style={{ fontSize: 18 }}
        onClick={(e) => {
          e.preventDefault();
          handleDownload(internalSubmission.resume_Insights_Pdfdoc, candidateDetails.fullName, "Resume-Insights");
        }}>
        <i className="fa fa-download icons"></i> Download Insights
      </a>
    </p>
  </OverlayTrigger>
)}

{/* 🔹 Others Document */}
{internalSubmission?.othersdoc && internalSubmission.othersdoc !== "" && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-others">Others</Tooltip>}>
    <p className="text-para">
      <a href="#"
        style={{ fontSize: 18 }}
        onClick={() => handleShowModal("Others", internalSubmission.othersdoc)}>
        <i className="fa fa-file icons"></i> View Others
      </a>
      &nbsp;|&nbsp;
      <a href="#"
        style={{ fontSize: 18 }}
        onClick={(e) => {
          e.preventDefault();
          handleDownload(internalSubmission.othersdoc, candidateDetails.fullName, "Others");
        }}>
        <i className="fa fa-download icons"></i> Download Others
      </a>
    </p>
  </OverlayTrigger>
)}

{/* 🔹 Visa Copy */}
{internalSubmission?.visaCopyUrl && internalSubmission.visaCopyUrl !== "" && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-visa">Visa Copy</Tooltip>}>
    <p className="text-para">
      <a href="#"
        style={{ fontSize: 18 }}
        onClick={() => handleShowModal("Visa Copy", internalSubmission.visaCopyUrl)}>
        <i className="fa fa-id-card icons"></i> View Visa Copy
      </a>
      &nbsp;|&nbsp;
      <a href="#"
        style={{ fontSize: 18 }}
        onClick={(e) => {
          e.preventDefault();
          handleDownload(internalSubmission.visaCopyUrl, candidateDetails.fullName, "Visa Copy");
        }}>
        <i className="fa fa-download icons"></i> Download Visa Copy
      </a>
    </p>
  </OverlayTrigger>
)}

{/* 🔹 Driving Licence */}
{internalSubmission?.drivingLicenceUrl && internalSubmission.drivingLicenceUrl !== "" && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-driving">Driving Licence</Tooltip>}>
    <p className="text-para">
      <a href="#"
        style={{ fontSize: 18 }}
        onClick={() => handleShowModal("Driving Licence", internalSubmission.drivingLicenceUrl)}>
        <i className="fa fa-id-card icons"></i> View Driving Licence
      </a>
      &nbsp;|&nbsp;
      <a href="#"
        style={{ fontSize: 18 }}
        onClick={(e) => {
          e.preventDefault();
          handleDownload(internalSubmission.drivingLicenceUrl, candidateDetails.fullName, "Driving Licence");
        }}>
        <i className="fa fa-download icons"></i> Download Driving Licence
      </a>
    </p>
  </OverlayTrigger>
)}

{/* 🔹 I94 */}
{internalSubmission?.i94File && internalSubmission.i94File !== "" && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-i94">I94</Tooltip>}>
    <p className="text-para">
      <a href="#"
        style={{ fontSize: 18 }}
        onClick={() => handleShowModal("I94", internalSubmission.i94File)}>
        <i className="fa fa-file icons"></i> View I94
      </a>
      &nbsp;|&nbsp;
      <a href="#"
        style={{ fontSize: 18 }}
        onClick={(e) => {
          e.preventDefault();
          handleDownload(internalSubmission.i94File, candidateDetails.fullName, "I94");
        }}>
        <i className="fa fa-download icons"></i> Download I94
      </a>
    </p>
  </OverlayTrigger>
)}


{/* 🔹 Passport */}
{internalSubmission?.passportURL && internalSubmission.passportURL !== "" && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-passport">Passport</Tooltip>}>
    <p className="text-para">
      <a
        href="#"
        style={{ fontSize: 18 }}
        onClick={() => handleShowModal("Passport", internalSubmission.passportURL)}
      >
        <i className="fa fa-file icons"></i> View Passport
      </a>
      &nbsp;|&nbsp;
      <a
        href="#"
        style={{ fontSize: 18 }}
        onClick={(e) => {
          e.preventDefault();
          handleDownload(internalSubmission.passportURL, candidateDetails.fullName, "Passport");
        }}
      >
        <i className="fa fa-download icons"></i> Download Passport
      </a>
    </p>
  </OverlayTrigger>
)}





                              
                              
                               <Modal show={showModal} onHide={handleCloseModal} size="lg">
                                    <Modal.Header closeButton>
                                        <Modal.Title>{modalContent.title}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {renderAttachment(modalContent.url)}
                                    </Modal.Body>
                                </Modal>
                            
                            </div>
                        </div>
                    </div>   
                     </Accordion.Body>
  </Accordion.Item>

   

                  </Accordion>
                </div>
            ) : (
                <center><LoadingSpinner /></center>
            )}
            <Modal show={showModal1} onHide={handleCloseModal1} size="lg" centered>
  <Modal.Header closeButton>
    <Modal.Title>{modalContent.title}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {renderAttachment(modalContent.url, modalContent.file, modalContent.html)}
  </Modal.Body>
</Modal>
<Modal show={showAssessmentModal} onHide={() => setShowAssessmentModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Custom Assessment Link</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {!assessmentMode && (
      <div className="d-flex flex-column gap-3">
        <button className="btn btn-outline-primary" onClick={() => setAssessmentMode("link")}>
          Enter Link Directly
        </button>
        <button className="btn btn-outline-secondary" onClick={() => setAssessmentMode("file")}>
          Upload File
        </button>
      </div>
    )}

    {assessmentMode === "link" && (
      <input
        type="text"
        className="form-control"
        placeholder="Enter Custom Assessment Link"
        {...register("customAssessmentLink")}
      />
    )}

    {assessmentMode === "file" && (
      <input
        type="file"
        accept="audio/*,.pdf,.doc,.docx,video/mp4,video/webm"
        className="form-control"
        onChange={(e) => setAssessmentFile(e.target.files[0])}
      />
    )}
  </Modal.Body>
  <Modal.Footer>
    <button className="btn btn-secondary" onClick={() => {
      setAssessmentMode("");
      setShowAssessmentModal(false);
    }}>
      Close
    </button>
    <button className="btn btn-primary" onClick={() => setShowAssessmentModal(false)}>
      Done
    </button>
  </Modal.Footer>
</Modal>
        </ConsultantLayout>
    );
};

export default BenchViewCandidateDetailsByCandidateGUid;





